import React, { useEffect, useState } from "react"
import { Button, Col, Form, Modal, Row } from "react-bootstrap"
import { Formik } from "formik";
import { SvgIcon } from "@mui/material";
import * as Yup from "yup";

import "../../assets/stlyes/SuperAdmin/SuperAdmin.scss"

import { saveSchool } from "../../api/superAdminApi"

import { Common, Regex, SUCCESS } from "../../helper";
import { isEmptyObject } from "../../util";
import { success } from "../Shared";


const AddSchoolModal = ({ showModal, setShowModal, isEdit, getSchoolDetails, school }) => {
  let originUrl = window.location.origin;
  const [schoolName, setSchoolName] = useState();
  const [schoolWebsiteUrl, setSchoolwebsiteUrl] = useState("");
  const [schoolId, setSchoolId] = useState();
  const [postalAddress, setPostalAddress] = useState();
  const [postalCode, setPostalCode] = useState();
  const [city, setCity] = useState();
  const [country, setCountry] = useState();
  const [contactFirstName, setContactFirstName] = useState();
  const [contactLastName, setContactLastName] = useState();
  const [contactEmail, setContactEmail] = useState();
  const [contactPhone, setContactPhone] = useState();
  const [billingAddress, setBillingAddress] = useState();
  const [vatNumber, setVatNumber] = useState();
  const [licenseNumber, setLicenseNumber] = useState();
  const [numberOfUsers, setNumberOfUsers] = useState(100);
  const [active, setActive] = useState(false);
  const [B2C, setB2C] = useState(false);
  const [currentDate, setCurrentDate] = useState();
  const [schoolCode, setSchoolCode] = useState("");
  const [isSameAddress, setIsSameAddress] = useState(false);

  const resetFormFields = () => {
    setSchoolName("");
    setSchoolwebsiteUrl("");
    setSchoolId("");
    setPostalAddress("");
    setPostalCode("");
    setCity("");
    setCountry("");
    setContactFirstName("");
    setContactLastName("");
    setContactEmail("");
    setContactPhone("");
    setBillingAddress("");
    setVatNumber("");
    setNumberOfUsers(numberOfUsers);
  };

  const handleCancel = () => {
    setShowModal(false)
    resetFormFields();
    setB2C(false);
  }

  const onSubmit = async (data, { setSubmitting }) => {
    setSubmitting(true);
    data.id ? setSchoolId(data.id) : setSchoolId("")
    data.active ? setActive(data.active) : setActive("")
    data.billingAddress ? setBillingAddress(data.billingAddress) : setBillingAddress("")
    data.city ? setCity(data.city) : setCity("")
    data.contactEmail ? setContactEmail(data.contactEmail) : setContactEmail("")
    data.contactFirstName ? setContactFirstName(data.contactFirstName) : setContactFirstName("")
    data.contactLastName ? setContactLastName(data.contactLastName) : setContactLastName("")
    data.contactPhone ? setContactPhone(data.contactPhone) : setContactPhone("")
    data.country ? setCountry(data.country) : setCountry("")
    data.licenses ? setLicenseNumber(licenseNumber) : setLicenseNumber("")
    data.numberOfUsers ? setNumberOfUsers(data.licenses) : setNumberOfUsers("")
    data.postalAddress ? setPostalAddress(data.postalAddress) : setPostalAddress("")
    data.postalCode ? setPostalCode(data.postalCode) : setPostalCode("")
    data.schoolName ? setSchoolName(data.schoolName) : setSchoolName("")
    data.schoolWebsiteUrl ? setSchoolwebsiteUrl(data.schoolWebsiteUrl) : setSchoolwebsiteUrl("")
    data.vatNumber ? setVatNumber(data.vatNumber) : setVatNumber("")
    let payload;
    isEdit ? payload = {
      id: schoolId,
      verificationLink: `${originUrl}/NewUser`,
      name: data.schoolName,
      website: data.schoolWebsiteUrl,
      address: {
        postalAddress: data.postalAddress,
        postCode: data.postalCode,
        city: data.city,
        country: data.country
      },
      active: active,
      billingDetails: {
        firstName: data.contactFirstName,
        lastName: data.contactLastName,
        email: data.contactEmail,
        phone: parseInt(data.contactPhone),
        billingAddress: {
          postalAddress: isSameAddress ? data.postalAddress : data.billingAddress,
          postCode: data.postalCode,
          city: data.city,
          country: data.country,
        },
        vatNumber: data.vatNumber,
        licenseNumber: `${data.schoolName.slice(0, 4).trim().toUpperCase()}-${currentDate}`
      },
      type: B2C ? 2 : 1,
      subscriptionDetails: {
        subscription: "",
        maxNumberOfUsers: data.numberOfUsers,
        expiry: "",
        startDate: "",
        endDate: ""
      }
    } : payload = {
      id: "",
      verificationLink: `${originUrl}/NewUser`,
      name: data.schoolName,
      website: data.schoolWebsiteUrl,
      address: {
        postalAddress: data.postalAddress,
        postCode: data.postalCode,
        city: data.city,
        country: data.country
      },
      active: true,
      billingDetails: {
        firstName: data.contactFirstName,
        lastName: data.contactLastName,
        email: data.contactEmail,
        phone: parseInt(data.contactPhone),
        billingAddress: {
          postalAddress: isSameAddress ? data.postalAddress : data.billingAddress,
          postCode: data.postalCode,
          city: data.city,
          country: data.country,
        },
        vatNumber: data.vatNumber,
        licenseNumber: `${data.schoolName.slice(0, 4).trim().toUpperCase()}-${currentDate}`,
      },
      type: B2C ? 2 : 1,
      subscriptionDetails: {
        subscription: "",
        maxNumberOfUsers: data.numberOfUsers,
        expiry: "",
        startDate: "",
        endDate: ""
      }
    }
    const _addSchool = await saveSchool(payload);

    if (!isEmptyObject(_addSchool)) {
      isEdit ? success(SUCCESS.SCHOOL_UPDATED) : success(SUCCESS.SCHOOL_CREATED)
      getSchoolDetails()
      setShowModal(false);
      resetFormFields();
      setB2C(false);
    } else {
      setSubmitting(false);
      setSchoolId(schoolId);
    }
  }

  const AddSchoolValidation = Yup.object().shape({
    schoolName: Yup.string().trim().matches(Regex.TextOnlyRegex, Common.NamesCannotContainNumbersOrSpecialCharacters).min(3, Common.CannotBeLessThan3Character).max(25, Common.LengthRestriction),
    postalAddress: Yup.string().trim().min(3, Common.CannotBeLessThan3Character).max(250, Common.LengthRestriction250),
    schoolWebsiteUrl: Yup.string().trim(),
    postalCode: Yup.string().trim().matches(Regex.PostalCodeRegexp, Common.PostalCodeRegexpMessage),
    country: Yup.string().trim().matches(Regex.TextOnlyRegex, Common.NamesCannotContainNumbersOrSpecialCharacters).min(3, Common.CannotBeLessThan3Character).max(25, Common.LengthRestriction),
    city: Yup.string().trim().matches(Regex.TextOnlyRegex, Common.NamesCannotContainNumbersOrSpecialCharacters).min(3, Common.CannotBeLessThan3Character).max(25, Common.LengthRestriction),
    contactFirstName: Yup.string().trim().matches(Regex.TextOnlyRegex, Common.NamesCannotContainNumbersOrSpecialCharacters).min(3, Common.CannotBeLessThan3Character).max(25, Common.LengthRestriction),
    contactLastName: Yup.string().trim().matches(Regex.TextOnlyRegex, Common.NamesCannotContainNumbersOrSpecialCharacters).max(25, Common.LengthRestriction),
    contactEmail: Yup.string().trim().matches(Regex.EmailRegExp, Common.InvalidEmailFormat),
    contactPhone: Yup.string().matches(Regex.OnlyNUmberRegex, Common.MustBeDigits).min(10, Common.PhoneNumberMustBeTenDigits).required(Common.PhoneNumberIsRequired),
    billingAddress: Yup.string().trim().min(3, Common.CannotBeLessThan3Character).max(250, Common.LengthRestriction250),
    vatNumber: Yup.string().trim().min(3, Common.CannotBeLessThan3Character).max(25, Common.LengthRestriction)
  })
  const getSchoolData = () => {
    if (!isEmptyObject(school?.Items)) {
      setActive(school.Items.active)
      setSchoolName(school.Items.name)
      setSchoolwebsiteUrl(school.Items.website)
      setSchoolId(school.Items.id)
      setPostalAddress(school.Items.address.postalAddress)
      setCity(school.Items.address.city)
      setCountry(school.Items.address.country)
      setPostalCode(school.Items.address.postCode)
      setContactFirstName(school.Items.billingDetails.firstName)
      setContactLastName(school.Items.billingDetails.lastName)
      setContactEmail(school.Items.billingDetails.email)
      setContactPhone(school.Items.billingDetails.phone)
      setVatNumber(school.Items.billingDetails.vatNumber)
      setBillingAddress(school.Items.billingDetails.billingAddress.postalAddress)
      setLicenseNumber(school.Items.billingDetails.licenseNumber)
      setNumberOfUsers(school.Items.subscriptionDetails.maxNumberOfUsers)
      setB2C(school.Items.type === 2);
    }
  }
  const updateSchoolCode = async (e) => {
    if (e) {
      let codeString = e.slice(0, 4);
      e.length > 2 ? setSchoolCode(codeString) : setSchoolCode("")
    }
  }
  useEffect(() => {
    if (isEdit) {
      getSchoolData()
    }
    else {
      setB2C(false);
      setLicenseNumber("");
    }
  }, [showModal])
  useEffect(() => {
    let today = new Date();
    setCurrentDate(`${today.getFullYear()}_${today.getMonth() + 1}_${today.getDate()}`)
  }, [])
  useEffect(() => {
    if (!isEdit) {
      schoolCode ? setLicenseNumber(`${schoolCode.toUpperCase()}-${currentDate}`) : setLicenseNumber("First 4 digits of School Name - Date(YYYY_MM_DD)")
    }
  }, [isEdit, currentDate, schoolCode])

  return (
    <div className="add-school-modal">
      <Modal show={showModal} size="xl" scrollable fullscreen="lg-down" backdrop={false} aria-labelledby="contained-modalModal-title-vcenter" centered>
        <Modal.Header closeButton={false}>
          <Modal.Title id="contained-modal-title-vcenter" style={{ display: "flex", width: "-webkit-fill-available", justifyContent: "space-between", alignItems: "center" }}>
            {isEdit ? Common.SuperAdmin.EditSchool : Common.SuperAdmin.AddSchool}
            <SvgIcon style={{ cursor: "pointer" }} onClick={() => { setShowModal(false); resetFormFields(); }}>
              <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0V0z" fill="none" /><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z" /></svg>
            </SvgIcon>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Formik
            enableReinitialize={isEdit}
            initialValues={{
              schoolName: schoolName,
              schoolWebsiteUrl: schoolWebsiteUrl,
              postalAddress: postalAddress,
              postalCode: postalCode,
              country: country,
              city: city,
              contactFirstName: contactFirstName,
              contactLastName: contactLastName,
              contactEmail: contactEmail,
              contactPhone: contactPhone,
              billingAddress: billingAddress,
              vatNumber: vatNumber,
              licenseNumber: licenseNumber,
              numberOfUsers: 100,
              active: active,
              type: B2C
            }}
            validationSchema={AddSchoolValidation}
            validate={() => {
              const errors = {};
              return errors;
            }}
            onSubmit={(values, { setSubmitting }) => {
              const schoolData = {
                schoolName: values.schoolName,
                schoolWebsiteUrl: values.schoolWebsiteUrl,
                postalAddress: values.postalAddress,
                postalCode: values.postalCode,
                country: values.country,
                city: values.city,
                contactFirstName: values.contactFirstName,
                contactLastName: values.contactLastName,
                contactEmail: values.contactEmail,
                contactPhone: values.contactPhone,
                billingAddress: values.billingAddress,
                vatNumber: values.vatNumber,
                licenseNumber: values.licenseNumber,
                active: values.active,
                numberOfUsers: 100
              };
              onSubmit(schoolData, { setSubmitting })
            }}>{({ values, errors, handleChange, handleBlur, handleSubmit, isSubmitting }) => (
              <Form onSubmit={handleSubmit} className="modal-form" >
                <Row><Form.Label>{Common.SuperAdmin.SchoolDetails}</Form.Label></Row>
                <hr />
                <Row>
                  <Col xs={3}>
                    <Form.Group className="mb-3" controlId="formBasic">
                      <Form.Label>{Common.SuperAdmin.SchoolName}</Form.Label>
                      <Form.Control type="text" placeholder={Common.SuperAdmin.SchoolName} name="schoolName"
                        onChange={(e) => {
                          handleChange(e);
                          updateSchoolCode(e.target.value);
                        }}
                        onBlur={handleBlur} onKeyDown={() => { updateSchoolCode(values.schoolName) }} value={values.schoolName} maxLength={25} />
                      {errors.schoolName && errors.schoolName && (<small style={{ color: "red" }}>{errors.schoolName}</small>)}
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="formBasic">
                      <Form.Label>{Common.SuperAdmin.SchoolWebsiteUrl}</Form.Label>
                      <Form.Control type="text" placeholder={Common.SuperAdmin.SchoolWebsiteUrl} name="schoolWebsiteUrl" onChange={handleChange} onBlur={handleBlur} value={values.schoolWebsiteUrl} maxLength={100} />
                    </Form.Group>
                  </Col>
                  <Col xs={1}></Col>
                  <Col xs={6}>
                    <Form.Group className="mb-3" controlId="formBasic">
                      <Form.Label>{Common.Address}</Form.Label>
                      <Form.Control as="textarea" placeholder={Common.Address} name={"postalAddress"} onChange={handleChange} onBlur={handleBlur} value={values.postalAddress} maxLength={250} />
                      {errors.postalAddress && errors.postalAddress && (<small style={{ color: "red" }}>{errors.postalAddress}</small>)}
                    </Form.Group>
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col xs={3}>
                    <Form.Group className="mb-3" controlId="formBasic">
                      <Form.Label>{Common.City}</Form.Label>
                      <Form.Control type="text" placeholder={Common.City} name={"city"} onChange={handleChange} onBlur={handleBlur} value={values.city} maxLength={25} />
                      {errors.city && errors.city && (<small style={{ color: "red" }}>{errors.city}</small>)}
                    </Form.Group>
                  </Col>
                  <Col xs={1}></Col>
                  <Col xs={3}>
                    <Form.Group className="mb-3" controlId="formBasic">
                      <Form.Label>{Common.Country}</Form.Label>
                      <Form.Control type="text" placeholder={Common.Country} name={"country"} onChange={handleChange} onBlur={handleBlur} value={values.country} maxLength={25} />
                      {errors.country && errors.country && (<small style={{ color: "red" }}>{errors.country}</small>)}
                    </Form.Group>
                  </Col>
                  <Col xs={1}></Col>
                  <Col xs={3}>
                    <Form.Group className="mb-3" controlId="formBasic">
                      <Form.Label>{Common.PostalCode}</Form.Label>
                      <Form.Control type="text" placeholder={Common.PostalCode} name={"postalCode"} onChange={handleChange} onBlur={handleBlur} value={values.postalCode} maxLength={8} />
                      {errors.postalCode && errors.postalCode && (<small style={{ color: "red" }}>{errors.postalCode}</small>)}
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Form.Group className="mb-3" controlId="formBasic">
                    <Row>

                      <Col xs={2}>
                        <Form.Label>{`${Common.SuperAdmin.LicenseNumber} :`}</Form.Label>
                      </Col>
                      <Col xs={1} />
                      <Col xs={4}>
                        <Form.Label>{licenseNumber}</Form.Label>
                      </Col>
                    </Row>
                  </Form.Group>
                </Row>
                <Row><Form.Label>{Common.SuperAdmin.ContactDetails}</Form.Label></Row>
                <hr />
                <Row>
                  <Col xs={3}>
                    <Form.Group className="mb-3" controlId="formBasic">
                      <Form.Label>{Common.FirstName}</Form.Label>
                      <Form.Control type="text" placeholder={Common.FirstName} name={"contactFirstName"} onChange={handleChange} onBlur={handleBlur} value={values.contactFirstName} maxLength={25} />
                      {errors.contactFirstName && errors.contactFirstName && (<small style={{ color: "red" }}>{errors.contactFirstName}</small>)}
                    </Form.Group>
                  </Col>
                  <Col xs={1}></Col>
                  <Col xs={3}>
                    <Form.Group className="mb-3" controlId="formBasic">
                      <Form.Label>{Common.LastName}</Form.Label>
                      <Form.Control type="text" placeholder={Common.LastName} name={"contactLastName"} onChange={handleChange} onBlur={handleBlur} value={values.contactLastName} maxLength={25} />
                      {errors.contactLastName && errors.contactLastName && (<small style={{ color: "red" }}>{errors.contactLastName}</small>)}
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col xs={3}>
                    <Form.Group className="mb-3" controlId="formBasicEmail">
                      <Form.Label>{Common.Email}</Form.Label>
                      <Form.Control type="email" placeholder={Common.Email} name={"contactEmail"} onChange={handleChange} onBlur={handleBlur} value={values.contactEmail} maxLength={50} />
                      {errors.contactEmail && errors.contactEmail && (<small style={{ color: "red" }}>{errors.contactEmail}</small>)}
                    </Form.Group>
                  </Col>
                  <Col xs={1}></Col>
                  <Col xs={3}>
                    <Form.Group className="mb-3" controlId="formBasic">
                      <Form.Label>{Common.Phone}</Form.Label>
                      <Form.Control type="text" placeholder={Common.Phone} name={"contactPhone"} onChange={handleChange} onBlur={handleBlur} value={values.contactPhone} maxLength={12} min="0" />
                      {errors.contactPhone && errors.contactPhone && (<small style={{ color: "red" }}>{errors.contactPhone}</small>)}
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col xs={3}>
                    <Row>
                      <Form.Group className="mb-3" controlId="formBasic">
                        <Form.Label>{Common.SuperAdmin.VatNumber}</Form.Label>
                        <Form.Control type="text" placeholder={Common.SuperAdmin.VatNumber} name={"vatNumber"} onChange={handleChange} onBlur={handleBlur} value={values.vatNumber} maxLength={15} />
                        {errors.vatNumber && errors.vatNumber && (<small style={{ color: "red" }}>{errors.vatNumber}</small>)}
                      </Form.Group>
                    </Row>
                    <Row>
                      {/* <Col xs={3} /> */}
                      <Col xs={4}>
                        <Form.Label>{Common.SuperAdmin.B2C}</Form.Label>
                      </Col>
                      <Col xs={2}>
                        <Form.Check checked={B2C} onChange={handleChange} onClick={() => setB2C(!B2C)} />
                      </Col>
                    </Row>
                  </Col>
                  <Col xs={1}></Col>
                  <Col xs={6}>
                    <Row>
                      <Form.Group className="mb-3" controlId="formBasic">
                        {/* <Form.Label>{Common.SuperAdmin.BillingAddress}</Form.Label> */}
                        <Form.Label className="d-flex">{Common.SuperAdmin.BillingAddress}<Form.Check checked={isSameAddress} style={{ marginLeft: "25px", display: "flex", alignItems: "center", gap: "5px", color: "rgba(0,0,0,0.5)" }} onChange={handleChange} onClick={() => setIsSameAddress(!isSameAddress)} label={"Same as Above"} /> </Form.Label>
                        <Form.Control as="textarea" disabled={isSameAddress} placeholder={Common.SuperAdmin.BillingAddress} style={{ height: "100px" }} name={"billingAddress"} onChange={handleChange} onBlur={handleBlur} value={values.billingAddress} maxLength={250} />
                        {errors.billingAddress && errors.billingAddress && (<small style={{ color: "red" }}>{errors.billingAddress}</small>)}
                      </Form.Group>
                    </Row>
                    <Row style={{ height: "50px" }}></Row>

                  </Col>
                </Row>
                <hr />
                <Form.Group>
                  <Row>
                    <Col xs={6}></Col>
                    <Col xs={3}>
                      <Button style={{ width: "150px", background: "#084059", borderRadius: "25px" }} type="submit" variant="success" disabled={isSubmitting}>
                        {isEdit ? Common.Update : Common.SuperAdmin.AddSchool}
                      </Button>
                    </Col>
                    <Col xs={3}>
                      <Button style={{ width: "150px", background: "transparent", color: "#404040", borderRadius: "25px", border: "1px solid #404040" }} onClick={handleCancel}>{Common.Cancel}</Button>
                    </Col>
                  </Row>
                </Form.Group>
              </Form>
            )}
          </Formik>
        </Modal.Body>
      </Modal>

    </div>
  )
}
export { AddSchoolModal }